import { createAsyncThunk } from '@reduxjs/toolkit'

import UserService from '../../UserService'

import { SEARCH_CLASS_BANNERS } from './classBannerSearch.actionTypes'

import { defaultErrorMessage } from '../../../constants'

export const searchClassBanners = createAsyncThunk(SEARCH_CLASS_BANNERS, async (data) => {
  try {
    const response = await UserService.searchClassBanners(data)

    if (response.data?.error) {
      throw new Error(response.data?.error?.detail || response.data?.error || defaultErrorMessage)
    }

    return response.data.data
  } catch (error) {
    console.log(error)
    throw error
  }
})
